import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';

import { Brand, FALLBACK_BRAND } from '../models/brand.model';
import { StorefrontService } from './storefront.service';

/**
 * Storefront data access. Everything the customer sees comes from the API:
 * the brand/storefront config (StorefrontService), the menu (MenuService),
 * branches (BranchService), orders (OrderApiService), etc. No bundled sample
 * data — this only exposes the API-backed brand.
 */
@Injectable({ providedIn: 'root' })
export class DataService {
  constructor(private storefront: StorefrontService) {}

  /** Brand from the published config (identity + commerce); neutral fallback until it loads. */
  getBrand(): Observable<Brand> {
    return of(this.storefront.brand ?? FALLBACK_BRAND);
  }

  /**
   * No bundled stock photos. Items carry their own `image_url` from the API;
   * where absent, the UI falls back to the brand logo. Kept for callers that
   * ask for an image by id — always null now (no static images).
   */
  photoFor(_id: string): string | null {
    return null;
  }
}
